<template>
  <div class="subscribe-page otp-login-page">
    <main>
      <section class="subscribe-hero">
        <img class="subscribe-prize" src="../../static/images/subscribe/prize_txt.png" alt="" />
        <header class="subscribe-header">
          <img src="../../static/images/logo1.png" alt="WowBox" />
        </header>
        <div class="subscribe-scroll">
          <div class="scroll-wrapper">
            <div class="scroll-item" v-for="(item, index) in scrollLightData" :key="index">{{ item }}</div>
          </div>
        </div>
      </section>

      <div class="subscribe-content">
        <div class="subscribe-phone">
          <img class="subscribe-prefix" src="../../static/images/subscribe/09.png" alt="09" />
          <input class="subscribe-number" :value="mobile" :aria-label="$t('landFont1')" type="tel" disabled />
        </div>

        <div class="otp-row">
          <input v-model="otp" class="otp-input" :placeholder="$t('enterOtp')" :aria-label="$t('enterOtp')" type="number" />
          <button class="otp-send-btn" type="button" :disabled="codeText !== $t('getCode')" @click="sendLoginOtp">
            {{ codeText }}
          </button>
        </div>

        <div class="subscribe-plans">
          <button class="subscribe-plan plan-daily" type="button" @click="verifyLoginOtp">
            <span class="plan-daily-copy">{{ $t('Login') }}<img class="plan-arrow" src="../../static/images/subscribe/arrow.png" alt="" /></span>
          </button>
        </div>

        <nav class="subscribe-links">
          <button type="button" @click="getChange('termsAndCondition2')">{{ $t('TC') }}</button>
          <button type="button" @click="getChange('faq2')">{{ $t('FAQ') }}</button>
        </nav>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobile: '',
      otp: '',
      codeText: '',
      timer: null,
      scrollLightData: {}
    }
  },
  created() {
    if (this.$route.query.mobile) {
      this.mobile = this.dealPhone_2(this.$route.query.mobile)
      this.sendLoginOtp();
    }
    this.codeText = this.$t('getCode')
    this.scrollLight()
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
  methods: {
    sendLoginOtp() {
      let that = this
      if (that.codeText !== that.$t('getCode')) return
      let mobile = '09' + that.mobile
      mobile = that.dealPhone(mobile)
      let data = {
        'mobile': mobile
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/login/login_send_otp', data, r => {
        that.$parent.loadModal(false);
        that.$parent.returnCode(r, function () {
          that.$utils.alertText(r.msg, 80)
          that.countDown(60)
        })
      })
    },
    verifyLoginOtp() {
      let that = this
      if (!that.otp) {
        that.$utils.alertText(that.$t('enterOtp'), 80)
        return
      }
      const deviceId = this.getDeviceId();
      let mobile = '09' + that.mobile
      mobile = that.dealPhone(mobile)
      let data = {
        'mobile': mobile,
        'otp': this.otp,
        'device_id': deviceId
      }
      that.$parent.loadModal(true)
      that.$api.post('/api/login/login_verify_otp', data, r => {
        that.$parent.loadModal(false)
        that.$parent.returnCode(r, function () {
          let userinfo = r.data && r.data.userinfo ? r.data.userinfo : {}
          localStorage.setItem('token', userinfo.token)
          localStorage.setItem('mobile', userinfo.mobile || that.mobile)
          that.$router.replace({path: '/'})
        })
      })
    },
    countDown(seconds) {
      if (seconds <= 0) {
        this.codeText = this.$t('getCode')
        return
      }
      this.codeText = seconds + 's'
      this.timer = setTimeout(() => this.countDown(seconds - 1), 1000)
    },
    scrollLight() {
      let that = this
      that.$api.post('/api/index/scroll_light', {}, r => {
        that.$parent.returnCode(r, function () {
          that.scrollLightData = r.data
        })
      })
    },
    getChange(type) {
      this.$router.push({path: '/' + type})
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
  }
}
</script>

<style scoped>
.subscribe-page {
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background: #080e36 url(../../static/images/index/main_bg.jpg) no-repeat center top;
  background-size: 100% 100%;
  color: #fff;
  font-family: Atom-sans;
}

.subscribe-hero {
  position: relative;
  width: 100%;
  aspect-ratio: 1125 / 1729;
}

.subscribe-prize {
  position: absolute;
  top: -0.55rem;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
}

.subscribe-header {
  position: absolute;
  z-index: 2;
  top: 0.6rem;
  left: 50%;
  width: 1.6rem;
  transform: translateX(-50%);
}

.subscribe-header img {
  display: block;
  width: 100%;
}

.subscribe-scroll {
  position: absolute;
  z-index: 2;
  top: 2.28rem;
  left: 6%;
  width: 88%;
  height: 0.68rem;
  overflow: hidden;
  border-top: 0.01rem solid rgba(69, 128, 255, 0.4);
  border-bottom: 0.01rem solid rgba(69, 128, 255, 0.4);
  background: linear-gradient(90deg, transparent, #005bdf 48%, transparent);
  font-size: 0.24rem;
  line-height: 0.34rem;
  text-align: center;
}

.scroll-wrapper {
  position: absolute;
  width: 100%;
  animation: scrollUp 60s linear infinite;
}

.scroll-item {
  height: 0.34rem;
  overflow: hidden;
  color: #fff;
  line-height: 0.34rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes scrollUp {
  from { transform: translateY(0); }
  to { transform: translateY(-100%); }
}

.subscribe-content {
  position: relative;
  z-index: 1;
  margin-top: -0.97rem;
  padding-bottom: 0.48rem;
}

.subscribe-phone {
  width: 4.97rem;
  height: 0.93rem;
  display: flex;
  align-items: center;
  margin: 0 auto;
  background: url(../../static/images/subscribe/phone_input_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.subscribe-prefix {
  display: block;
  width: 1.14rem;
  height: 0.71rem;
  margin-left: 0.09rem;
  object-fit: contain;
}

.subscribe-number {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 0.32rem;
  border: 0;
  background: transparent;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.38rem;
  letter-spacing: 0;
}


.subscribe-number::placeholder {
  color: #757da9;
  -webkit-text-fill-color: #757da9;
  font-size: 0.28rem;
  opacity: 1;
}

.subscribe-plans {
  margin-top: 0.5rem;
}

.subscribe-plan {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  color: #fff;
  font-family: Atom-sans-bold;
  cursor: pointer;
}

.plan-daily {
  width: 3.85rem;
  height: 1.35rem;
  margin: 0 auto;
  background: url(../../static/images/subscribe/daily_btn_bg.png) no-repeat center;
  background-size: 100% 100%;
  font-size: 0.38rem;
}

.plan-daily-copy {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.plan-arrow {
  width: 0.19rem;
  height: 0.31rem;
  margin-left: 0.08rem;
  object-fit: contain;
}

.subscribe-links {
  width: 5rem;
  display: flex;
  justify-content: space-between;
  gap: 0.3rem;
  margin: 1.89rem auto 0;
}

.subscribe-links button {
  min-width: 1.4rem;
  padding: 0;
  border: 0;
  background: none;
  color: #b7b4ea;
  font-family: Atom-sans;
  font-size: 0.27rem;
  text-align: center;
  text-decoration: underline;
  text-underline-offset: 0.05rem;
}

.subscribe-number::-webkit-inner-spin-button,
.subscribe-number::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.otp-login-page .subscribe-content {
  padding-bottom: 0.48rem;
}

.otp-login-page .subscribe-number:disabled {
  opacity: 1;
  -webkit-text-fill-color: #fff;
}

.otp-row {
  width: 4.97rem;
  height: 0.93rem;
  display: flex;
  align-items: center;
  margin: 0.2rem auto 0;
  background: url(../../static/images/subscribe/phone_input_bg.png) no-repeat center;
  background-size: 100% 100%;
}

.otp-input {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 0 0.32rem;
  border: 0;
  background: transparent;
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.34rem;
}

.otp-input::placeholder {
  color: #757da9;
  -webkit-text-fill-color: #757da9;
  font-size: 0.27rem;
  opacity: 1;
}

.otp-send-btn {
  flex: 0 0 1.86rem;
  height: 0.72rem;
  margin-right: 0.1rem;
  padding: 0 0.06rem;
  border: 0.02rem solid #8eefff;
  border-radius: 0.4rem;
  background: linear-gradient(#397bff, #03c9ee);
  color: #fff;
  font-family: Atom-sans-bold;
  font-size: 0.24rem;
  cursor: pointer;
}

.otp-send-btn:disabled {
  opacity: 0.65;
  cursor: default;
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.otp-login-page .subscribe-plans {
  margin-top: 0.18rem;
}

.otp-login-page .subscribe-links {
  margin-top: 0.56rem;
}
</style>



// WEBPACK FOOTER //
// src/page/otpLogin.vue